<aside class="secondary-sidepanel" *ngIf="navService.getRequestPane()"
       (clickOutside)="navService.toggleRequestPane()">
  <div class="secondary-sidepanel__content" @openClose>
    <!-- Notification Screen -->
    <div class="notification-screen-wrapper">
      <div class="notification-screen">
        <div class="notification-screen__header">
          <h5>
            Requests
            <!-- <span class="counter" *ngIf="unreadCount | async as uc">
              ({{ uc }})
            </span> -->
          </h5>
        </div>

        <ng-scrollbar style="height: calc(100vh - 160px);">
          <div class="card-panel card-panel--request-card" *ngFor="let req of convService.requests;let i = index;">
            <div class="card-panel__title" style="margin: 0;">
              <div class="contact-profile contact-profile--request-card" (click)="toggleDetails(req)">
                <div class="contact-profile__picture">
                  <div class="user-avatar user-avatar--request-card">
                    <span class="user-avatar__img">
                      <i [ngClass]="getIcon(req.channelType)"></i>
                    </span>
                    <i class="user-avatar__status-icon"></i>
                  </div>
                </div>
          
                <div class="contact-profile__name">
                  <h5>Request</h5>
                  <button (click)="acceptChat(i, req);$event.stopPropagation();"
                    class="single-button--with-bg single-button--with-bg-success">accept</button>
                </div>
              </div>
            </div>
            <div class="card-panel__details" [ngClass]="{'hidden': !req.showDetails }">
              <div class="name-value-pair name-value-pair--user-info">
                <span class="name-value-pair__label">Campaign</span>
                <p class="name-value-pair__value has-ellipsis">{{req.campaignName}}</p>
              </div>
              <div class="name-value-pair name-value-pair--user-info">
                <span class="name-value-pair__label">Time</span>
                <p class="name-value-pair__value has-ellipsis">{{moment(req.dateCreated).format('MM-DD-YYYY hh:mm:ss A')}}</p>
              </div>
              <div class="name-value-pair name-value-pair--user-info">
                <span class="name-value-pair__label">Channel</span>
                <p class="name-value-pair__value has-ellipsis">{{getChannelName(req.channelType)}}</p>
              </div>
              <div class="name-value-pair name-value-pair--user-info">
                <span class="name-value-pair__label">Nick Name</span>
                <p class="name-value-pair__value has-ellipsis">{{req.nickName}}</p>
              </div>
              <div class="name-value-pair name-value-pair--user-info">
                <span class="name-value-pair__label">Message</span>
                <p class="name-value-pair__value has-ellipsis">{{req.messageText}}</p>
              </div>
              <div class="name-value-pair name-value-pair--user-info">
                <span class="name-value-pair__label">Source</span>
                <p class="name-value-pair__value has-ellipsis">{{req.customerInfo.siteUrl || req.site.url || 'N/A'}}</p>
              </div>
              <div class="name-value-pair name-value-pair--user-info">
                <span class="name-value-pair__label">Address</span>
                <p class="name-value-pair__value has-ellipsis">{{req.customerInfo.country ?? ''}} {{req.customerInfo.city ?? ''}}
                  {{req.customerInfo.state ?? ''}} {{req.customerInfo.zip ?? ''}}</p>
              </div>
              <div class="name-value-pair name-value-pair--user-info">
                <span class="name-value-pair__label">Visitor</span>
                <p class="name-value-pair__value">{{req.returningVisitor ? "Existing" : "New"}}</p>
              </div>
            </div>
          </div>
        </ng-scrollbar>
      </div>
    </div>
  </div>
</aside>
